<template>
    <el-dialog 
      :visible.sync="dialogInvoiceVisible" 
      custom-class="invoice" 
      width="592px"
      :close-on-click-modal="false"
      :before-close="close"
    >
      <div slot="title" class="invoice-dialog-title">
        <span>申请发票</span>
        <span>9020320 | 广州沃雨森实业有限公司 | 数采宝 铂金会员 | 46,400.00RMB</span>
      </div>
      <div class="invoice-title">
        <div class="invoice-type">发票类型</div>
        <div>
          <el-button>全电专用发票</el-button>
          <el-button>全电普通发票</el-button>
        </div>
      </div>
      <div class="invoice-content">
        <div class="invoice-msg">发票信息</div>
        <el-form 
          :model="ruleForm" 
          :rules="rules" 
          ref="ruleForm" 
          label-position="left"
        >
          <el-form-item label="企业信息(全称)" :label-width="formLabelWidth" prop="name">
            <el-input style="width:386px;" v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="纳税人识别号" :label-width="formLabelWidth" prop="number">
            <el-input v-model="ruleForm.number"  placeholder="请输入15,18或20位纳税人识别号" style="width:386px;"></el-input>
          </el-form-item>
          <el-form-item label="地址" :label-width="formLabelWidth" prop="address">
            <el-input class="addressInput" type="textarea" v-model="ruleForm.address" placeholder="请输入地址" style="width:386px;"></el-input>
          </el-form-item>
          <el-form-item label="电话" :label-width="formLabelWidth" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入电话" style="width:386px;"></el-input>
          </el-form-item>
          <el-form-item label="开户行" :label-width="formLabelWidth" prop="bank">
            <el-input v-model="ruleForm.bank" placeholder="请输入开户行" style="width:386px;"></el-input>
          </el-form-item>
          <el-form-item label="银行账号" :label-width="formLabelWidth" prop="bankAccount">
            <el-input v-model="ruleForm.bankAccount" placeholder="请输入银行账号" style="width:386px;"></el-input>
          </el-form-item>
          <el-form-item label="开票金额" :label-width="formLabelWidth" prop="amount">
            <el-input
              v-model="ruleForm.amount"
              placeholder="请输入开票金额"
              style="width:240px;margin-right:25px;"
            ></el-input>
            <span style="font-size: 12px;font-family: SourceHanSansCN-Medium;">可开票金额0.00(RMB)</span>
          </el-form-item>
          <el-form-item label="电子邮箱"  :label-width="formLabelWidth" prop="email" style="margin-bottom:15px;">
            <el-input v-model="ruleForm.email" placeholder="请输入电子邮箱" style="width:386px;"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" style="line-height:16px;">
            <span class="invoice-tip">温馨提示:请确认发票信息正确无误,HAIZOL.COM核对后会将电子发票投递至您的电子邮箱</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel('ruleForm')">取 消</el-button>
          <el-button type="primary" @click="confirm('ruleForm')">确 定</el-button>
        </div>

      </div>
    </el-dialog>
</template>

<script>
export default {
  props:{
    dialogInvoiceVisible:{
      type: Boolean,
      default: false
    }
  },
  data(){
    // 纳税人识别号
    var isIdentifyNumber = (rule,value,callback)=>{
      if(!value){
        callback()
      }else{
        const reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
        const identifyNumber = reg.test(value);
        if(!identifyNumber){
          callback(new Error('请填写正确的纳税人识别号'))
        }else{
          callback()
        }
      }
    }
    // 银行账号校验
    var isBankAccount = (rule, value, callback) => {
      const strBin =
        "10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99";
      if (!value) {
        return callback(new Error("收款账户不能为空"));
      } else if (!Number.isInteger(+value)) {
        callback(new Error("银行卡号必须全为数字"));
      } else if (value.trim().length < 12 || value.trim().length > 19) {
        callback(new Error("银行卡号长度必须在12到19之间"));
      } else if (strBin.indexOf(value.substring(0, 2)) === -1) {
        callback(new Error("银行卡号开头6位不符合规范"));
      } else {
        callback();
      }
    }
    // 电话校验
    var isPhoneOrMobile = (rule,value,callback)=>{
      console.log(rule,'---------');
      const mobilereg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/ // 手机
      const phonereg = /^0\d{2,3}-?\d{7,8}$/ // 固话
      rule.phonetype = rule.phonetype || 'mobile'
      if (rule.phonetype === 'mobile') {
        if (value && !mobilereg.test(value)) {
          callback(new Error('请输入正确的手机号')) 
        }else callback()
      }else if (rule.phonetype === 'phone') {
        if (value && !phonereg.test(value))
          callback(new Error('请输入正确的电话号码'))
        else callback()
      }else{
          callback(new Error('请输入电话号码'))
      }

    }

    return {
      formLabelWidth:'110px',
      ruleForm: {
        name: '',
        number: '',
        address: '',
        phone: '',
        bank: '',
        bankAccount: '',
        amount: '',
        email: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
        ],
        number: [
          { required: true,message: '请输入15,18或20位纳税人识别号',validator:isIdentifyNumber, trigger: 'blur'},
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        phone: [
          { required: true,validator:isPhoneOrMobile, trigger: 'blur' }
        ],
        bankAccount: [
          {  required: true, message: '请输入银行账号', validator:isBankAccount, trigger: 'blur' }
        ],
        bank: [
          {  required: true, message: '请填写开户行', trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '请输入开票金额', trigger: 'blur' }
        ],
        email: [
          { type: 'email',required: true, message: '请填写邮箱', trigger: 'blur' }
        ]
      },
      dialogInvoiceVisible2: this.dialogInvoiceVisible
    }
  },
  computed:{
  
  },
  methods:{
    close(){
      this.dialogInvoiceVisible2 = false
      this.$emit('getChangeInvoice',this.dialogInvoiceVisible2)
    },
    cancel(formName){
      this.$refs[formName].resetFields();
      this.dialogInvoiceVisible2 = false
      this.$emit('getChangeInvoice',this.dialogInvoiceVisible2)
    },
    confirm(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
            this.dialogInvoiceVisible2 = false
            this.$emit('getChangeInvoice',this.dialogInvoiceVisible2)

          } else {
            console.log('error submit!!');
            return false;
          }
        });
    }
  },
  created(){
  }
};
</script>

<style lang="scss" scoped>
.invoice{
  width: 592px;
  .invoice-dialog-title{
    // padding: 32px 32px 10px;
    :nth-child(1){
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #16181A;
      margin-right:40px;
    }
    :nth-child(2){
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #4F5D78;
    }
  }
  .invoice-title{
    display: flex;
    align-items: center;
    padding:28px 28px 25px;
    border-bottom: 1px solid #EDF0F4;
    >div{
      margin-right: 54px;
    }
    .invoice-type{
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #16181A;
    }
  }
  .invoice-content{
    padding:24px 28px 35px;
    .invoice-tip{
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #FF7F2A;
    }
    .dialog-footer{
      width: 496px;
      text-align: right;
    }
   
  }
  .invoice-msg{
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #16181A;
    margin-bottom:24px;
  }
  
}
</style>
<style lang="scss">
.invoice{
  .el-form-item:last-child{
    .el-form-item__content{
      line-height: 16px;
    }
  }
  .el-form-item__label{
    font-size: 12px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 400;
  }
  .el-dialog__header{
    padding: 32px 31px 0 32px;
  }
  .el-dialog__body{
    padding:0 20px;
  }
  .el-dialog__headerbtn{
    top:35px;
    right:32px;
    font-weight: 600;
    font-size: 20px;
    color: #98A3B7;

  }
  .invoice-content{
    .addressInput{
      .el-textarea__inner{
        height: 80px;
        font-size: 12px;
        resize: none;
      }
    }
    .el-input__inner{
      font-size: 12px;
      font-family: SourceHanSansCN-Regular;
    }

  }
  .dialog-footer{
    .el-button{
      width: 56px;
      padding: 9px 13px;
    }
  }
}
</style>